/*
 * Attempt to use a high resolution timestamp when in the browser environment, but fallback to Date.now
 * When the performance API is not available.
 */
// TODO: performance.now() returns a time relative to page load while Date.now() is relative to unix epoch.
// Should probably change performance.now to be relative to unix epoch by adding performance.timing.navigationStart,
// but first need to audit this doesn't break any usages.
export function getNow(): number {
  if (typeof performance !== `undefined`) {
    return performance.now();
  }
  return Date.now();
}

export function diffFromNow(timestamp: number): number {
  return getNow() - timestamp;
}

export const PERFORMANCE_EVENT_PREFIX = `ui-perf`;
export const WEB_DASH_PREFIX = `Web Dash`;
export const CROSS_PROJECT_TRACKING_PREFIXES = [PERFORMANCE_EVENT_PREFIX, WEB_DASH_PREFIX];
